import React, { useState } from 'react';
import { Drawer, Radio } from 'antd';
import i18next from 'i18next';
import { optionsLanguageMobile } from './constants';
import AuthButtons from './AuthButtons';

const Sheet = ({ onOpen, onClose }) => {
  const [language, setLanguage] = useState(localStorage.getItem('i18lang'));
  const onChangeLanguage = ({ target: { value } }) => {
    setLanguage(value);
    i18next.changeLanguage(value);
    localStorage.setItem('i18next', value);
  };
  return (
    <Drawer
      title="Центр карьеры"
      placement={'right'}
      closable={true}
      onClose={onClose}
      open={onOpen}
      key={'left'}
      width={230}
    >
      <div className="d-flex flex-column gap-3 mt-2">
        <div className="d-flex justify-content-center">
          <Radio.Group
            options={optionsLanguageMobile}
            onChange={onChangeLanguage}
            value={language}
            optionType="button"
          />
        </div>
        <div className="d-flex flex-column gap-2">
          <AuthButtons />
        </div>
      </div>
    </Drawer>
  );
};

export default Sheet;
